import React from "react";
import type { Editor } from "@tiptap/react";
import { Button } from "@/components/ui/button";
import {
  Link as LinkIcon,
  Minus,
  Table as TableIcon,
  ImageIcon,
} from "lucide-react";

interface InsertGroupProps {
  editor: Editor;
  disabled: boolean;
  isUploading: boolean;
  onToggleFormat: (format: string) => void;
  onToggleLink: () => void;
  onImageUpload: () => void;
}

export function InsertGroup({
  editor,
  disabled,
  isUploading,
  onToggleFormat,
  onToggleLink,
  onImageUpload,
}: InsertGroupProps) {
  return (
    <>
      <Button
        type="button"
        variant={editor.isActive("link") ? "default" : "ghost"}
        size="sm"
        onClick={onToggleLink}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title={editor.isActive("link") ? "Edit or remove link" : "Add link"}
      >
        <LinkIcon className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onToggleFormat("hr")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Horizontal Rule"
      >
        <Minus className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onToggleFormat("table")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Insert Table"
      >
        <TableIcon className="h-4 w-4" />
      </Button>

      {/* Image Upload */}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onImageUpload}
        disabled={disabled || isUploading}
        className="h-8 w-8 p-0 flex-shrink-0"
        title={isUploading ? "Uploading..." : "Insert Image"}
      >
        <ImageIcon className="h-4 w-4" />
      </Button>
    </>
  );
}
